import { Button, ButtonProps, Component, DataSourceMode, TableRowToolsCell, TableRowToolsCellBehavior, TableRowToolsViewer } from "@mcleod/components";
import { getThemeColor } from "@mcleod/core";
import { AppTableRowToolsCellReveal } from "./AppTableRowToolsCellReveal";

const minimumReveal = 70;

export class AppTableRowToolsCellBehavior extends TableRowToolsCellBehavior {
    protected constructor() {
        super();
    }

    override manageToolsCellWidth(cell: TableRowToolsCell, cellWidth: number): void {
        cellWidth = minimumReveal;
        cell.width = cellWidth;
        cell.toolsPanel.width = cellWidth;
        cell.table.toolsCellAdded(0);
    }

    override shouldAddDragHandler(cell: TableRowToolsCell): boolean {
        return false; // row re-sequencing not supported at this time.
    }

    override shouldAddSlideoutButton(cell: TableRowToolsCell): boolean {
        return false; // slideout supported via tapping row (edit) or FAB (add)
    }

    override get deleteButtonProps(): Partial<ButtonProps> {
        return {
            ...super.deleteButtonProps,
            displayLabel: "Delete",
            color: getThemeColor("error")
        };
    }

    override setupToolCellPanel(
        cell: TableRowToolsCell, ellipsisButton: Button, viewer: TableRowToolsViewer, tools: Component[]
    ): void {
        if (viewer) {
            viewer.width = cell.width;
            cell.toolsPanel.add(viewer);
        }

        // Everything else below is one-time setup.
        // Ensures we don't create multiple listeners for the same cell via the handler.
        const dataSourceMode = cell.row?.table?.dataSource?.mode;
        if (dataSourceMode !== DataSourceMode.SEARCH) {
            if (cell["revealHandler"] !== undefined) {
                return;
            }

            cell.toolsPanel.setProps({ height: "100%", isRow: true });
            cell.toolsPanel._element.style.display = "grid";
            AppTableRowToolsCellReveal.addHandler(cell, viewer, tools);
        }
    }
}

AppTableRowToolsCellBehavior.register();
